import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReduxProvider from "./store/ReduxProvider";
import { BrowserRouter } from "react-router";
import { initializeMocks } from "./mocks/initializeMocks";
import "./i18n";
import { ENV_VARIABLES } from "./Config/env-config";

const startApp = () => {
  const container: HTMLElement = document.getElementById("root")!;
  const root = createRoot(container);

  //todo remove later start - this is just for deployment config testing.
  console.log("test deployment from ocp");

  console.log(ENV_VARIABLES.REACT_APP_HOMEPAGE);
  console.log(ENV_VARIABLES.REACT_APP_GRANT_TYPE);
  console.log(ENV_VARIABLES.REACT_APP_CLIENT_ISSUER);
  console.log(ENV_VARIABLES.REACT_APP_CLIENT_ID);
  //todo remove later end- this is just for deployment config testing.

  const homepage = ENV_VARIABLES.REACT_APP_HOMEPAGE;
  root.render(
    <BrowserRouter basename={homepage}>
      <ReduxProvider>
        <App />
      </ReduxProvider>
    </BrowserRouter>
  );
};

// Initialize mocks and start the app
initializeMocks().finally(startApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
